<script lang="ts">
	import { getTranslate } from "../utils/getTranslate.js";
	import Link from "./Link.svelte";
	import Review from "./Review.svelte";
	import translations from "./Reviews.translations.json";
	import imgMarek from "../../../core/assets/images/marek-marian-lezdik.webp?webp&w=83&imagetools";
	import imgDavid from "../../../core/assets/images/david-vostry.png?webp&w=83&imagetools";
	import imgRadim from "../../../core/assets/images/radim-linhart.webp?webp&w=83&imagetools";

	export let reviewsHeadline = "";
	export let tryApp = "";
	export let href = "#";
	const translate = getTranslate(translations);
	/* eslint-disable svelte/no-at-html-tags */
</script>

<div class="bg-secondary container max-w-[81.75rem] py-16 text-white lg:rounded-md lg:px-12 lg:py-32 lg:pb-16">
	<h2 class="text-md mb-16 text-center lg:text-lg">{@html reviewsHeadline}</h2>
	<div class="flex flex-col items-center justify-center gap-6 lg:flex-row lg:flex-wrap lg:items-stretch">
		<Review
			content={translate("reviewContent1")}
			img={imgRadim}
			author="Radim Linhart"
			role={translate("reviewRole1")}
		/>
		<Review
			content={translate("reviewContent2")}
			img={imgMarek}
			author="Marek Marián Leždík"
			role={translate("reviewRole2")}
		/>
		<Review
			content={translate("reviewContent3")}
			img={imgDavid}
			author="David Vostrý"
			role={translate("reviewRole3")}
		/>
	</div>
	<Link variant="primary" asButton {href} class="mx-auto mt-12">
		{@html tryApp}
	</Link>
</div>
